import store from '@/store/store';
import HelpModal from '@/components/HelpModal';
import { EventBus } from '@/store/eventBus';

const SubmissionBoilerplate = {
    components: { HelpModal },

    props: {
        fieldId: {
            type: String,
            required: true
        },

        fieldNamespace : {
            type: String,
            required: true
        }
    },

    data() {
        return {
            fieldData: [],
            storage: this.$storageURL,
        };
    },

    computed: {
        name() {
            return store.state[this.fieldNamespace].name;
        },

        population() {
            return store.state[this.fieldNamespace].population;
        },

        submission() {
            return store.state[this.fieldNamespace].submission;
        },

        helpTitle() {
            return store.state[this.fieldNamespace].options.helpTitle;
        },

        helpText() {
            return store.state[this.fieldNamespace].options.helpText;
        },
    },

    created() {
        this.loadFieldData();
        EventBus.$on(`${this.fieldNamespace}UpdateFieldData`, (fieldData) => this.updateFieldData(fieldData));
    },

    methods: {
        updateFieldData(fieldData) {
            this.fieldData = fieldData;
            this.storeFieldData();
        },

        storeFieldData() {
            store.commit(`${this.fieldNamespace}/setEntry`, this.fieldData);
        }
    }
};

export default SubmissionBoilerplate;
